import * as React from "react";
import { useDispatch } from "react-redux";

// style, design
import ModalChapter from "../../Base/Chapters/ModalChapter";
import renderChapter from "./renderChapter";

// store, state
import chapterDefs from "./chapterDefs";
import {
  constants,
  create,
  useParkingSpotAdForm,
  destroyPatchForm,
  destroyPostForm,
  update,
  detailUrl,
} from "../../../../store/marketParkingAds";
import { setActiveFormInstance } from "../../../../store/base";
import { useHistory } from "react-router-dom";

export default function ParkingSpotAdForm({
  method,
  id,
  isOpen,
  onCheckout,
  hideParkingSpot,
  instance,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const { push } = useHistory();

  const formLoaded = Boolean(useParkingSpotAdForm(method, id));

  const checkout = (success) => {
    if (method === "POST") {
      dispatch(destroyPostForm(success));
    } else if (method === "PATCH") {
      dispatch(destroyPatchForm(success));
    }

    onCheckout();
  };

  React.useEffect(() => {
    if (instance) {
      dispatch(
        setActiveFormInstance({
          storeName: constants.STORE_NAME,
          data: instance,
        })
      );
    }
  }, [isOpen]);

  React.useEffect(() => {
    return () => {
      dispatch(
        setActiveFormInstance({ storeName: constants.STORE_NAME, data: {} })
      );
    };
  }, []);

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);
    if (method === "POST") {
      push(detailUrl({ id: returned?.id }));
    }
  };

  const onSubmit = () => {
    setLoading(true);
    if (method === "POST") {
      dispatch(
        create({
          successCallback: onSuccess,
          errorCallback: () => setLoading(false),
        })
      );
    } else if (method === "PATCH") {
      dispatch(
        update({
          id,
          successCallback: onSuccess,
          errorCallback: () => setLoading(false),
        })
      );
    }
  };

  const onDone = () => {
    checkout(false);
  };

  return (
    <ModalChapter
      storeName={constants.STORE_NAME}
      chapterDefs={chapterDefs}
      onRenderChapter={(key) => renderChapter({ key, method, hideParkingSpot })}
      submitCallback={onSubmit}
      title={method === "POST" ? "Skapa annons" : "Uppdatera annons"}
      onDone={onDone}
      loading={!formLoaded || loading}
      isOpen={isOpen}
    />
  );
}
